import { SimpleGrid, VStack } from '@chakra-ui/react';
import loadable from '@loadable/component';
import { useMemo } from 'react';
import { useTypedSelector } from '../../../../../hooks/store';
import {
  selectChooseShotDetailActivity,
  selectStatusSkytrakPlus,
} from '../../../../../slices/activitySkytrak';
import { selectAllCategoryClubs } from '../../../../../slices/myBags';
import { backgroundCategory } from '../../ReturnIconBackgroundCategory';
import { ActivitySkytrak } from '../../../../../models/activitySkytrak';

const ContentRightRow1 = loadable(() => import('./ContentRightRow1'));
const ContentRightRow2 = loadable(() => import('./ContentRightRow2'));
const ContentRightRow3 = loadable(() => import('./ContentRightRow3'));
const ContentLeft = loadable(() => import('./ContentLeft'));

type ModalShowDetailShotProps = {
  item: ActivitySkytrak;
};

const ContentShowDetailShot = ({ item }: ModalShowDetailShotProps) => {
  const chooseShotDetail = useTypedSelector(selectChooseShotDetailActivity);
  const checkSkytraPlus = useTypedSelector(selectStatusSkytrakPlus);
  const allClubCategoryClub = useTypedSelector(selectAllCategoryClubs);

  const colorClub = useMemo(() => {
    if (chooseShotDetail) {
      if (item.subTypeAbbrev === 'WdgMtxGamImprv') {
        switch (chooseShotDetail.swingTypeName) {
          case 'Pitch':
            return '#CC52B4';
          case '1/2':
            return '#B9F961';
          case '3/4':
            return '#59B6F7';
          case 'Full':
            return '#EFE759';
          default:
            return '#EFE759';
        }
      } else {
        return backgroundCategory(
          allClubCategoryClub,
          chooseShotDetail.clubType
        );
      }
    }
    return '#D247E7';
  }, [allClubCategoryClub, chooseShotDetail, item]);

  return (
    chooseShotDetail && (
      <SimpleGrid
        columns={6}
        background={'#26272B'}
        rounded={20}
        textTransform={'uppercase'}
        sx={{
          div: {
            fontFamily: "'Roboto Condensed', sans-serif",
          },
        }}
      >
        {checkSkytraPlus && (
          <VStack
            spacing={'0px'}
            color={'#FFF'}
            borderRight={'2px solid rgba(255, 255, 255, 0.2)'}
          >
            <ContentLeft colorClub={colorClub} />
          </VStack>
        )}
        <VStack
          spacing={'0px'}
          color={'#FFF'}
          gridColumn={checkSkytraPlus ? '2/7' : '1/7'}
        >
          <ContentRightRow1 colorClub={colorClub} />
          <ContentRightRow2 colorClub={colorClub} />
          <ContentRightRow3 colorClub={colorClub} />
        </VStack>
      </SimpleGrid>
    )
  );
};

export default ContentShowDetailShot;
